// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityFilterController from "./activity_filter_controller"
application.register("activity-filter", ActivityFilterController)

import ActivityFiltersController from "./activity_filters_controller"
application.register("activity-filters", ActivityFiltersController)

import AmbassadorAuthController from "./ambassador_auth_controller"
application.register("ambassador-auth", AmbassadorAuthController)

import AmbassadorDetailsController from "./ambassador_details_controller"
application.register("ambassador-details", AmbassadorDetailsController)

import AssignmentModalController from "./assignment_modal_controller"
application.register("assignment-modal", AssignmentModalController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BadgePreviewController from "./badge_preview_controller"
application.register("badge-preview", BadgePreviewController)

import BadgeTooltipController from "./badge_tooltip_controller"
application.register("badge-tooltip", BadgeTooltipController)

import BaseListController from "./base_list_controller"
application.register("base-list", BaseListController)

import BaseViewController from "./base_view_controller"
application.register("base-view", BaseViewController)

import BrowserPluginController from "./browser_plugin_controller"
application.register("browser-plugin", BrowserPluginController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ClientListController from "./client_list_controller"
application.register("client-list", ClientListController)

import ClientStatusController from "./client_status_controller"
application.register("client-status", ClientStatusController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CreateClientController from "./create_client_controller"
application.register("create-client", CreateClientController)

import CreateProjectController from "./create_project_controller"
application.register("create-project", CreateProjectController)

import DeleteTaskController from "./delete_task_controller"
application.register("delete-task", DeleteTaskController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditorJsController from "./editor_js_controller"
application.register("editor-js", EditorJsController)

import EffortAllocationController from "./effort_allocation_controller"
application.register("effort-allocation", EffortAllocationController)

import ExternalLinksController from "./external_links_controller"
application.register("external-links", ExternalLinksController)

import FeedbackInfiniteScrollController from "./feedback_infinite_scroll_controller"
application.register("feedback-infinite-scroll", FeedbackInfiniteScrollController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormController from "./form_controller"
application.register("form", FormController)

import FullCalendarController from "./full_calendar_controller"
application.register("full-calendar", FullCalendarController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import GuideListController from "./guide_list_controller"
application.register("guide-list", GuideListController)

import GuideNavigationController from "./guide_navigation_controller"
application.register("guide-navigation", GuideNavigationController)

import HeaderTrackingController from "./header_tracking_controller"
application.register("header-tracking", HeaderTrackingController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import LeadFormController from "./lead_form_controller"
application.register("lead-form", LeadFormController)

import LeadValidationController from "./lead_validation_controller"
application.register("lead-validation", LeadValidationController)

import LoadingStateController from "./loading_state_controller"
application.register("loading-state", LoadingStateController)

import LoginFormController from "./login_form_controller"
application.register("login-form", LoginFormController)

import LoginVideoController from "./login_video_controller"
application.register("login-video", LoginVideoController)

import MilestoneListController from "./milestone_list_controller"
application.register("milestone-list", MilestoneListController)

import MilestoneSchedulerController from "./milestone_scheduler_controller"
application.register("milestone-scheduler", MilestoneSchedulerController)

import MilestoneViewController from "./milestone_view_controller"
application.register("milestone-view", MilestoneViewController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalFormController from "./modal_form_controller"
application.register("modal-form", ModalFormController)

import NoteFormController from "./note_form_controller"
application.register("note-form", NoteFormController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PasskeysController from "./passkeys_controller"
application.register("passkeys", PasskeysController)

import PermissionCheckboxController from "./permission_checkbox_controller"
application.register("permission-checkbox", PermissionCheckboxController)

import PinController from "./pin_controller"
application.register("pin", PinController)

import PriorityGuidesBarController from "./priority_guides_bar_controller"
application.register("priority-guides-bar", PriorityGuidesBarController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ProjectListController from "./project_list_controller"
application.register("project-list", ProjectListController)

import ProjectPulseTimelineController from "./project_pulse_timeline_controller"
application.register("project-pulse-timeline", ProjectPulseTimelineController)

import ProjectStatusController from "./project_status_controller"
application.register("project-status", ProjectStatusController)

import QuizOptionsController from "./quiz_options_controller"
application.register("quiz-options", QuizOptionsController)

import QuoteRotatorController from "./quote_rotator_controller"
application.register("quote-rotator", QuoteRotatorController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollToSectionController from "./scroll_to_section_controller"
application.register("scroll-to-section", ScrollToSectionController)

import ShareNoteController from "./share_note_controller"
application.register("share-note", ShareNoteController)

import SharedNoteHighlightController from "./shared_note_highlight_controller"
application.register("shared-note-highlight", SharedNoteHighlightController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskDateController from "./task_date_controller"
application.register("task-date", TaskDateController)

import TaskFilterController from "./task_filter_controller"
application.register("task-filter", TaskFilterController)

import TasksController from "./tasks_controller"
application.register("tasks", TasksController)

import TeamFilterController from "./team_filter_controller"
application.register("team-filter", TeamFilterController)

import TeamListController from "./team_list_controller"
application.register("team-list", TeamListController)

import TeamMemberFormController from "./team_member_form_controller"
application.register("team-member-form", TeamMemberFormController)

import TeamPlanningController from "./team_planning_controller"
application.register("team-planning", TeamPlanningController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeReportController from "./time_report_controller"
application.register("time-report", TimeReportController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import TrixEditorController from "./trix_editor_controller"
application.register("trix-editor", TrixEditorController)

import UppyUploadController from "./uppy_upload_controller"
application.register("uppy-upload", UppyUploadController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoProgressController from "./video_progress_controller"
application.register("video-progress", VideoProgressController)

import WelcomeVideoProgressController from "./welcome_video_progress_controller"
application.register("welcome-video-progress", WelcomeVideoProgressController)

import WorkLoggingController from "./work_logging_controller"
application.register("work-logging", WorkLoggingController)
